if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      // Look the container up at the moment it's needed, not in the constructor,
      // because the markup may not exist yet when the element is constructed.
      getContentContainer() {
        return this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        const container = this.getContentContainer();
        if (container) container.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);

        const container = this.getContentContainer();
        if (!container) {
          console.error('quick-add-modal: no QuickAddInfo-* container found inside <quick-add-modal>');
          return;
        }

        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) {
          console.error('quick-add-modal: opener has no data-product-url to fetch');
          return;
        }

        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

            this.productElement =
              responseHTML.querySelector('section[id^="MainProduct-"]') ||
              responseHTML.querySelector('section[id^="CardProduct-"]');

            if (!this.productElement) {
              console.error('quick-add-modal: no product markup found at', productUrl);
              return;
            }

            // Re-query in case the DOM changed while the request was in flight.
            const currentContainer = this.getContentContainer();
            if (!currentContainer) {
              console.error('quick-add-modal: container disappeared before content could be inserted');
              return;
            }

            this.setInnerHTML(currentContainer, this.productElement.innerHTML);
            this.preventVariantURLSwitching();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          })
          .catch((error) => {
            console.error('quick-add-modal: failed to load product', error);
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Re-create script tags so they execute (innerHTML doesn't run them).
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const container = this.getContentContainer();
        const variantPicker = container && container.querySelector('variant-selects');
        if (!variantPicker) return;
        variantPicker.setAttribute('data-update-url', 'false');
      }
    }
  );
}